// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eM","menuControls_styleDefault":"c-a_eN","menuControls_styleRed":"c-a_eO"};